<template>
  <mt-popup v-model="showPop"
            class='selectShift select-wrap'
            popup-transition="popup-fade">
    <!--班别选择-->
    <h2>{{$t("MessageBox_selectShiftTitle")}}</h2>
    <div class='select-list-wrap'>
      <mt-radio
        v-model="currentCode"
        :options="shiftArr">
      </mt-radio>
    </div>
    <div class="btn">
      <div class="unSure"
           @click="showPop=false">{{$t('cancel')}}
      </div>
      <div class="sure"
           @click="save">{{$t('determine')}}
      </div>
    </div>
  </mt-popup>
</template>
<script>
  export default {
    data() {
      return {
        showPop: false,
        currentCode: '',
        shiftArr: [],
        req: {
          id: null,
          remark: null,
        }
      };
    },

    props: {},

    mounted() {
      this.getShiftList()
    },

    methods: {
      getShiftList() {
        const self = this
        this.$http.post("/mobilepmsapi/accounting/classesReturn").then(res => {
          if (res.data.result == 0) {
            var retVal = res.data.retVal || {}
            let arr = retVal.classes || []
            arr.map((item, index) => {
              // 为了使用 mint ui的 radio，格式改一下
              item.label = item.code + ' - ' + item.name
              item.value = item.code || ''
              self.shiftArr.push(item)
            })
          } else {
            this.msg2(res.data.msg);
          }
        });
      },

      show(code) {
        this.showPop = true;
        this.currentCode = code || '';
      },

      getShiftItem() {
        const self = this
        let temp = {}
        this.shiftArr.map((item, index) => {
          if (self.currentCode == item.code) {
            temp.name = item.name || ''
            temp.code = item.code || ''
          }
        })
        return temp
      },

      save() {
        if (this.currentCode) {
          this.showPop = false
          this.$http.post("/mobilepmsapi/sys/setUserCashier",{
            cashier: this.currentCode
          }).then(res => {
            if (res.data.result == 0) {
            } else {
              this.msg2(res.data.msg);
            }
          });

          this.$emit('success', this.getShiftItem())
        } else {
          this.msg2(this.$t('MessageBox_msg_selectShift')) // '请选择班别'
        }
      },
    },
  };
</script>

<style lang="less">
  .select-wrap {
    width: 80%;
    position: fixed;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;

    .select-list-wrap {
      min-height: 320px;
      max-height: 380px;
      overflow-y: scroll;
    }

    h2 {
      font-size: 18px;
      color: #666666;
      text-align: center;
      font-style: normal;
      padding: 15px 0;
    }

    .mint-cell-title {
      width: 80px;
    }

    .btn {
      height: 55px;
      border-top: 1px solid #bdbdbd;
      text-align: center;
      font-size: 16px;
      width: 100%;

      .unSure {
        border-right: 1px solid #bdbdbd;
        width: 50%;
        box-sizing: border-box;
        float: left;
        line-height: 55px;
      }

      .sure {
        width: 50%;
        box-sizing: border-box;
        float: left;
        line-height: 55px;
        color: #5190c3;
      }

      .unSure,
      .sure {
        &:active {
          background: #eaeaea;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// selectShift.vue?6d6ebf29